// export { default as data } from './data';
import { Language } from '../interfaces';

export const LOG_TAG = 'UI: ';
export const READ_FROM_CLIPBOARD = 'READ_FROM_CLIPBOARD';
export const INITIAL_KEYBOARD_LOAD_DELAY = 200;
export const APP_HEADER_LOGO_ASPECT_RATIO = 240 / 40;
export const DEFAULT_APP_LANGUAGE = { key: 'en_US', name: 'English' } as Language;
export const HOME_STATIC_PROMO_CARDS_TYPES = ['tournament', 'referral'];

export const MILLI_SECONDS_IN_A_DAY = 86400000;

export const DATE_FORMATS = {
  YYYYMMDD: 'YYYY-MM-DD',
  DDMMYYYY: 'MM/DD/YYYY',
  DDMMMYYYY: 'DD MMM YYYY',
  DDMMMMYYYY: 'DD MMM YYYY',
  HMMDDMMMYYYY: 'h:mm a, DD MMM YYYY',
  DDMMM: 'DD MMM',
  MMMDD: 'MMM DD',
  DDMMYYYY_hhmmss: 'DD MMMM YYYY hh:mm:ss',
  DDMMYYYY_hhmmssa: 'D MMMM YYYY hh:mm:ssa',
  MMDDYYYY_hhmmssa: 'MM/DD/YYYY hh:mm:ssa',
  YYYYMMDD_HHmmss: 'YYYY-MM-DD HH:mm:ss',
  YYYYMMDD_HHmmssa: 'YYYY-MM-DD HH:mm:ssa',
  DDMM_hhmmss: 'DD MMMM hh:mm:ss',
  hhmmss_a: 'hh:mm:ssa',
  hmm_a: 'h:mm A',
  MMM_YYYY: 'MMM YYYY',
  HHmm: 'HH:mm',
  HHmmss: 'HH:mm:ss',
  hmm__a: 'h:mma',
  MM_DD: 'MM/DD',
};

//'H [h]:mm [m]:ss [s]' | 'H:m:ss' | 'H:m' | 'm:ss' | 'ss'
export const TIME_FORMATS = {
  Hh_Mm_Ss: 'H [h]:m [m]:ss [s]',
  Hh_Mm: 'H [h]:m [m]',
  Mm_Ss: 'm [m]:ss [s]',
  Dd_Hh_Mm: 'D [d]: H [h]:m [m]',
  Dd_Hh: 'D [d]: H [h]',
  HH_MM_SS: 'HH:mm:ss',
  HMS: 'H:m:s',
  HM: 'H:m',
  HMM: 'H:mm',
  MS: 'm:s',
  SS: 'ss',
  Ss: 'ss [s]',
};

export const CALANDER_MONTHS = [
  ['JAN', 'FEB', 'MAR', 'APR'],
  ['MAY', 'JUN', 'JUL', 'AUG'],
  ['SEP', 'OCT', 'NOV', 'DEC'],
];

export const LANGUAGES = {
  en_US: { key: 'en', display: 'English', letters: 'Aa' },
};

export enum AppTheme {
  DARK = 'dark',
  LIGHT = 'light',
}

export enum AppThemeType {
  USER_PREFERRED = 'light',
  SYSTEM = 'system',
}

export enum AppSDKTransitionType {
  BackToApp = 'back_to_app',
  BackToSDK = 'back_to_sdk',
  None = 'do_nothing',
}

export enum AppScreenStatusType {
  sdkActive = 1,
  sdkBackground = 2,
  appActive = 3,
  appBackground = 4,
}

export enum AppEventType {
  AppInBackground = 'app_sent_to_background',
  AppInForeground = 'app_brought_to_foreground',
}

export enum LocationCheckEvent {}

export enum PermissionCheckEvent {}

//KEEPING SAME LOG TAG ACCROSS A FLOW, SO THAT IT'S EASY TO FILTER LOGS AND CHECK ONE FLOW.
//THESE ARE USED AS FIREBASE EVENT NAME, SO ONLY ALPHA_NUERIC AND UDERSCORE ARE ALLOWED.
export enum LogTags {
  APP_INIT = 'UI_APP_INIT',
  AUTH = 'UI_AUTH',
  SHARE = 'SHARE',
}

export enum NwConnectionStatus {
  DEFAULT,
  CONNECTED,
  DISCONNECTED,
  LOW_NETWORK,
  RECONNECTED,
}

export const DEFAULT_RETRY_CONFIG = {
  retry: 1,
  retryDelay: 2000,
};

export enum SnackBarIconType {
  ALERT,
  DEFAULT,
  LOW_BATTERY,
  LOW_NETWORK,
}

export enum SnackBarAlertType {
  LOW_BATTERY,
  LOW_NETWORK,
}

export enum SoundType {}

export enum AppErrorStatusCode {
  NOT_FOUND = 404,
  SERVER_ERROR = 500,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  ERR_NETWORK = 'ERR_NETWORK',
  ERR_NETWORK_CONNECTION_REFUSED = 'ERR_CONNECTION_REFUSED',
  NONE = 'NO_ERROR',
}

export enum DocumentTypeEnum {
  SHIFT_REPORT = 'SHIFT_REPORT',
  CASH_ENTRY = 'CASH_ENTRY',
  VOID_ENTRY = 'VOID_ENTRY',
  USER_DOC = 'USER_DOC',
  ENTERPRISE_DOC = 'ENTERPRISE_DOC',
  STORE_DOC = 'STORE_DOC',
  LOTTERY_DOC = 'LOTTERY_DOC',
  BRAND_DOC = 'BRAND_DOC',
  LOTTERY_SALES = 'LOTTERY_SALES',
  MO_ENTRY = 'MO_ENTRY',
  DROPS_ENTRY = 'DROPS_ENTRY',
  LOSS_ENTRY = 'LOSS_ENTRY',
  LOTTERY_PO = 'LOTTERY_PO',
  COUPON_SALES = 'COUPON_SALES',
  MISC_PO = 'MISC_PO',
  MONEY_ORDER_DOC = 'MONEY_ORDER_DOC',
  DAY_REPORT_SALES = 'DAY_REPORT_SALES',
  DAY_REPORT_CASH_PO = 'DAY_REPORT_CASH_PO',
  DAY_REPORT_CASH_DEP = 'DAY_REPORT_CASH_DEP',
  DAY_REPORT_GAS_SALES = 'DAY_REPORT_GAS_SALES',
}

export enum SalesAttachmentTypeEnum {
  CASH_ENTRY = 'CASH_ENTRY',
  LOTTERY_SALES = 'LOTTERY_SALES',
  MO_ENTRY = 'MO_ENTRY',
  DROPS_ENTRY = 'DROPS_ENTRY',
  LOSS_ENTRY = 'LOSS_ENTRY',
  LOTTERY_PO = 'LOTTERY_PO',
  MISC_PO = 'MISC_PO',
  VOID_ENTRY = 'VOID_ENTRY',
  COUPON_SALES = 'COUPON_SALES',
  DAY_REPORT_SALES = 'DAY_REPORT_SALES',
  DAY_REPORT_CASH_PO = 'DAY_REPORT_CASH_PO',
  DAY_REPORT_CASH_DEP = 'DAY_REPORT_CASH_DEP',
  DAY_REPORT_GAS_SALES = 'DAY_REPORT_GAS_SALES',
}

export enum ShiftReportStatusEnum {
  DRAFT = 'DRAFT',
  UNDER_REVIEW = 'UNDER_REVIEW',
  APPROVED = 'APPROVED',
  SUBMITTED = 'SUBMITTED',
}

export enum ReportStatusEnum {
  DRAFT = 'DRAFT',
  UNDER_REVIEW = 'UNDER_REVIEW',
  APPROVED = 'APPROVED',
  SUBMITTED = 'SUBMITTED',
}

export enum ReportType {
  SHIFT_REPORT = 'SHIFT_REPORT',
  DAY_REPORT = 'DAY_REPORT',
}

export const ASSETS_CACHED_PATH = 'image-assets-cache';

export type DropdownItem = {
  value: number | string;
  key: string;
  label: string;
  multiSelect?: boolean;
};
